import Alert from "../../utils/messages";
import ClassicEditor from "../../ckeditor";
import Utils from "../../utils/Utils";

export default {

    init() {

        function parseResponseError(error) {

            if (error.response) {

                const status = error.response.status;

                if (status === 422) {
                    return Alert.buildMessageList(Alert.parseValidationExceptionResponse(error.response));
                } else {
                    return Alert.buildMessageList("Non è stato possibile eseguire l'aggiornamento");
                }
            } else {
                return Alert.buildMessageList("Non è stato possibile eseguire l'aggiornamento");
            }
        }

        const QUIETANZA = "quietanza";
        const MANDATO = "mandato";
        const PREZZO_CONCORDATO = "prezzo_concordato";

        const TABLE_PRODUCTS = "#table-products";
        const TABLE_PRODUCTS_BODY = "#table-products > tbody";

        const MODAL_CREATE_EDIT_PRODUCT = "#modal-ce-product";
        const MODAL_CREATE_EDIT_PRODUCT_TITLE = "#modal-ce-product-title";

        const MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE = "#modal-ce-product-input-type";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE = "#modal-ce-product-input-code";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS = "#modal-ce-product-input-symbols";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_DESCRIPTION = "#modal-ce-product-input-description";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG = "#modal-ce-product-input-catalog";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COST = "#modal-ce-product-input-cost";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION = "#modal-ce-product-input-commission";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE = "#modal-ce-product-input-selling-price";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE = "#modal-ce-product-input-agreed-price";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_DESCRIPTION = "#modal-ce-product-input-catalog-description";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES = "#modal-ce-product-input-notes";
        const MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT = "#modal-ce-product-btn-submit";

        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER = "#modal-ce-product-col-input-catalog-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER = "#modal-ce-product-col-input-commission-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER = "#modal-ce-product-col-input-cost-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER = "#modal-ce-product-col-input-selling-price-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER = "#modal-ce-product-col-input-agreed-price-wrapper";

        const ROW_ERRORS = "#modal-ce-product #row-errors";
        const LIST_ERRORS = "#modal-ce-product #list-errors";

        const BTN_EDIT_PRODUCT = ".btn-edit-product";
        const BTN_TOGGLE_IS_FAKE_ATTRIBUTE = ".btn-toggle-is-fake-attribute";
        const BTN_DELETE_PRODUCT = ".btn-delete-product";

        const DATA_PRODUCT_ID = "product-id";

        const SINGOLO = "singolo";
        const COLLEZZIONE = "collezione";

        let _editors = [];

        let _selected_product = null;

        function setupWysiwyg() {

            for (const editor of _editors) {
                editor.destroy();
            }

            _editors = [];

            const elements = document.querySelectorAll(".wysiwyg");

            for (const element of elements) {
                ClassicEditor.create(element).then(editor => {
                    editor.editing.view.change(writer => {
                        writer.setStyle('height', '100px', editor.editing.view.document.getRoot());
                    });
                    //_editors.push(editor);
                    _editors.push({
                        id: element.id,
                        editor: editor,
                    })
                });
            }
        }

        function updateWysiwygSource() {

            for (const editor of _editors) {
                editor['editor'].updateSourceElement();
            }
        }

        function updateWysiwygData(id, data) {
            for (const editor of _editors) {
                if (editor.id === id) {
                    const wysiwyg = editor.editor;
                    wysiwyg.setData(data);
                    wysiwyg.updateSourceElement();
                }
            }
        }

        function clearModalCreateEditProduct() {

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val($(`${MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE} option:first`).val()).change();
            //CODE WILL BE CHANGED AUTOMATICALLY
            //$(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val('');
            //$(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).attr('checked', false);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).val('');
            updateWysiwygData('modal-ce-product-input-description', '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG).val(0);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST).val(0);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION).val(0);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE).val(0);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE).val(0);
            updateWysiwygData('modal-ce-product-input-catalog-description', '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES).val('');
            $(MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT).data(DATA_PRODUCT_ID, '');

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).addClass('d-none');

            $(LIST_ERRORS).html('');
            $(ROW_ERRORS).hide();
        }

        function fillModalCreateEditProduct(product) {
            clearModalCreateEditProduct();

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val(product.type).change();
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val(product.code);
            /*$(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).prop('checked', false);

            for (const symbol of product.symbols) {
                $(`${MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS}[value=${symbol}]`).prop('checked', true);
            }*/
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).val(product.symbols.join(','));

            updateWysiwygData('modal-ce-product-input-description', product.description ?? '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG).val(product.catalog);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST).val(product.cost);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION).val(product.commission);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE).val(product.selling_price);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE).val(product.agreed_price);
            updateWysiwygData('modal-ce-product-input-catalog-description', product.catalog_description ?? '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES).val(product.notes);
            $(MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT).data(DATA_PRODUCT_ID, product.id);

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).addClass('d-none');

            switch (product.purchasing_channel_type) {
                case QUIETANZA:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).removeClass('d-none');
                    break;
                case MANDATO:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).removeClass('d-none');
                    break;
                case PREZZO_CONCORDATO:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).removeClass('d-none');
                    break;
            }

        }

        function getModalCreateEditProductData() {
            updateWysiwygSource();

            /*const symbols = [];

            $(`${MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS}:checked`).each(function (index, symbol) {
                symbols.push($(symbol).val());
            });*/

            const symbols = $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).val().split(',');

            const data = {
                type: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val(),
                code: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val(),
                symbols: symbols,
                description: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_DESCRIPTION).val(),
                catalog: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG).val(),
                cost: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST).val(),
                commission: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION).val(),
                selling_price: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE).val(),
                agreed_price: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE).val(),
                catalog_description: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_DESCRIPTION).val(),
                notes: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES).val(),
            }

            return data;
        }

        function updateProduct(product_id, data, callback) {

            httpRequest.put(`admin/content/api/products/${product_id}`, data)
                .then(response => {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                })
                .catch(error => {
                    $(LIST_ERRORS).html(parseResponseError(error));
                    $(ROW_ERRORS).show();
                });
        }

        function productDeleted(product_id) {
            $(TABLE_PRODUCTS_BODY).find(`tr[data-product-id=${product_id}]`).remove();
        }

        function deleteProduct(product_id) {

            httpRequest.delete(`admin/content/api/products/${product_id}`)
                .then(response => productDeleted(product_id))
                .catch(error => {

                    const response = error.response;

                    if (response) {
                        const error = response.data.error;

                        if (!Utils.isEmpty(error) && error === "product_has_been_sold") {
                            alert("Non è possibile eliminare un prodotto venduto!");
                        } else {
                            alert("Non è stato possibile eliminare il prodotto selezionato!");
                        }
                    } else {
                        alert("Non è stato possibile eliminare il prodotto selezionato!")
                    }

                });
        }

        function showModalCreateEditProduct() {
            clearModalCreateEditProduct();
            $(MODAL_CREATE_EDIT_PRODUCT).modal('show');
        }

        function hideModalCreateEditProduct() {
            clearModalCreateEditProduct();
            $(MODAL_CREATE_EDIT_PRODUCT).modal('hide');
        }

        function productLoaded(product, callback) {

            _selected_product = product;

            if (callback && typeof callback === "function") {
                callback(product);
            }
        }

        function loadProduct(product_id, callback) {

            httpRequest.get(`admin/content/api/products/${product_id}`)
                .then(response => productLoaded(response.data.data, callback))
                .catch(error => {
                });
        }

        function inputProductTypeChanged(protocol_number, type) {

            let code = protocol_number;

            if (type === SINGOLO) {
                code = code + "/s"
            } else if (type === COLLEZZIONE) {
                code = code + "/"
            }

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val(code);
        }

        $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).change(function (e) {
            inputProductTypeChanged(_selected_product.purchasing_channel.protocol_number, $(this).val());
        });

        $(MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT).click(function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            const data = getModalCreateEditProductData();

            console.log(product_id);

            if (Utils.isEmpty(product_id)) {

            } else {
                updateProduct(product_id, data, function () {
                    //renderProductsTable(_purchasing_channel.id, data['type']);
                    hideModalCreateEditProduct();
                    window.location.reload();
                });
            }

        });

        $(TABLE_PRODUCTS_BODY).on('click', BTN_EDIT_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            loadProduct(product_id, function (product) {
                showModalCreateEditProduct();
                fillModalCreateEditProduct(product);
                $(MODAL_CREATE_EDIT_PRODUCT_TITLE).text("Modifica articolo");
            });
        });

        function toggleIsFakeAttribute(product_id) {

            httpRequest.put(`admin/content/api/products/${product_id}/toggle-is-fake-attribute`)
                .then(response => window.location.reload())
                .catch(error => {
                })
        }

        $(TABLE_PRODUCTS_BODY).on('click', BTN_TOGGLE_IS_FAKE_ATTRIBUTE, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            const is_fake = parseInt($(this).data('is-fake'));

            let confirm_message = is_fake ? 'Vuoi veramente ripristinare il prodotto selezionato?' : 'Vuoi veramente marcare come falso o difettoso il prodotto selezionato?';
            if (confirm(confirm_message)) {
                toggleIsFakeAttribute(product_id);
            }

        });

        $(TABLE_PRODUCTS_BODY).on('click', BTN_DELETE_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) && confirm("Vuoi veramente eliminare il prodotto selezionato?")) {
                deleteProduct(product_id);
            }
        });

        setupWysiwyg();
    },

    finalize() {

    }
}
